import bodyMoving from 'bodymovin';

const AnimationManager = {
	install(Vue, options) {
		let animations = {};
		
		Vue.loadAnimation = (name, url , element, ratio, successCallback) =>{
			let animation = bodyMoving.loadAnimation({
				container: element,
				renderer: 'svg',
				autoplay: false,
				path: url,
				rendererSettings: {
					progressiveLoad: true,
					preserveAspectRatio: 'xMidYMid '+ratio
				},
			});
			
			animation.addEventListener('DOMLoaded', ()=>{
				animations[name] = animation;
				if(successCallback != undefined) successCallback();
			});
			
			//animation.play();
			//console.log(animation);
		}
		
		Vue.unloadAnimation = (name) =>{
			let animation = animations[name];
			if(animation == null || animation == undefined) return;
			animation.destroy();
			delete animations[name];
		};
		
		
		Vue.getAnimation = (name,settings) =>{
			let animation = animations[name];
			if(animation == null || animation == undefined){
				console.log("AnimationManager doesnt contain a animation called: " + name);
				return null;
			}
			if(settings != undefined && settings != null){
				animation.loop= settings.loop || false;
			}
			else{
				animation.loop = false;
			}
			return animation;
		};
		
		Vue.playAnimation = (name , settings) =>{
			let animation = animations[name];
			if(animation == null || animation == undefined){
				console.log("AnimationManager doesnt contain a animation called: " + name);
				return null;
			}
			
			if(settings != undefined && settings != null){
				animation.loop= settings.loop || false;
			}
			else{
				animation.loop = false;
			}
			
			if(!animation.isPaused){
				animation.goToAndPlay(0,true);
			}
			else animation.play();
			
			return animation;
			
			
		};
		
	}
}

export default AnimationManager;


// WEBPACK FOOTER //
// ./src/plugins/AnimationManager.js